module.exports = __webpack_public_path__ + "static/media/hands-healthy-life-hygiene-svgrepo-com.ec02038f.svg";